export default __webpack_public_path__ + "static/media/backpack1.5d6b4cd8.jpeg";